<template>
  <div class="noPage">
    <Header />
    您访问的页面不存在
  </div>
</template>

<script>
import { errorLog } from "api/user";
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
      errorLog("","页面不存在："+ location.href + ' , ' + navigator.userAgent);
  },
  methods: {},
};
</script>

<style scoped lang="less">
.noPage {
  height: 200px;
  margin: 65px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
